import { useEffect, useState } from "react"
import Input from "../../../components/Input"
import Map from "../../../components/Map"
import Popup from "../../../components/Popup"
import Select from "../../../components/Select"
import { authAxios } from "../../../helpers/axios"
import ImageInput from "../../../components/ImageInput"
import CropPopup from "../../../components/CropPopup"
import { RETAILER_IMAGE_BASE_URL } from "../../../helpers/constants"
import { dataURItoBlob } from "../../../helpers/utils"
import { data } from "../../dashboard/components/PriceData"
import SmallPopup from "../../../components/SmallPopup"

export default function RevertBlendPopup({onClose,edit=false,onSubmit,submitting})
{
    const formName = 'revertBlend';

    return <><SmallPopup title={'Revert Blend' } submitting={submitting} submitTitle={'Submit'} onClose={onClose} formName={formName}>
        <form name={formName} onSubmit={(e)=>onSubmit(e,{productionBlendId:edit?.id})} id={formName} className='w-full'>
            <div className="mb-4">
                <p className="text-sm font-medium ">Are you sure you want to revert the blend with blend name "{edit?.blendUsed?.blendName}" and batch number "#{edit?.blendUsed?.batchNumber}"?</p>
            </div>
        </form>
    </SmallPopup>
    </>
}